module.exports = __webpack_public_path__ + "static/media/mentionNotification.5a7d9f42.mp3";